import {
    Drawer as UiDrawer,
} from "@mui/material"

import { SIDEBAR_WIDTH } from "../../constants/layout"
import { styledForMobile } from "../../utils/styledForMobile"


interface CustomDrawerProps {
    shadowed: boolean
}

export const Drawer = styledForMobile<typeof UiDrawer, CustomDrawerProps>(UiDrawer, ["shadowed"])(
    ({ isMobile, shadowed, theme }) => ({
        boxShadow: shadowed ? "0px 0px 8px 0px rgba(0, 0, 0, 0.10)" : "",
        position: "relative",
        height: !isMobile && "100%",
        width: isMobile ? "100%" : SIDEBAR_WIDTH,
        flex: isMobile && 1,
        overflowY: "auto",
        zIndex: theme.zIndex.drawer + 1,
        "& .MuiDrawer-paper": {
            position: "absolute",
            height: "100%",
            width: "100%",
            borderWidth: 0,
            padding: !isMobile && theme.spacing(8, 0, 0, 0),
        },
    })
)